var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[(_vm.withLink)?_c('a',{attrs:{"href":_vm.copyrightLink,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.copyright)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.copyright)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }